import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'app-manual-customer',
  templateUrl: './manual-customer.page.html',
  styleUrls: ['./manual-customer.page.scss'],
})
export class ManualCustomerPage implements OnInit {

  @Input() public activecustomer: any;

  public appPages = [
    {
      title: "Search",
      url: "/customer-search",
      icon: "mail",
      action: 1,
    },
    {
      title: "Data Detail",
      url: "/customer-detail",
      icon: "paper-plane",
      action: 2,
    }
  ];

  constructor(public router: Router, public appService: AppService) {}

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.activecustomer = value;
    });
  }

  ionViewDidEnter(){
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.activecustomer = value;
    });
  }

  clickMenu(item) {
    if (item.action === 1) {
      this.appService.setActive(item.action);
      this.router.navigate([item.url]);
    }
  }

}
